export const iconFontAwesomeGamingChessKnight = (
	<i className="fa-solid fa-chess-knight"></i>
);
